<template>
    <component :is="template">
        <v-responsive width="100%">
            <v-card elevation="0" tile>
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">포인트내역</h2>
                </div>

                <v-divider class="d-md-none" />
                <div class="py-20px pt-md-0px pb-md-40px text-center">
                    <div class="tit tit--xs"><b class="black--text">{{ me?.name }}</b>님의 포인트</div>
                    <div class="mt-1"><b class="tit tit--lg primary--text font-weight-bold">{{ parseInt(+me?.point || 0 ).format() }}</b> 원</div>
                </div>
                <v-divider/>

                <div>
                    <v-data-table :items="points" :headers="pointsHeaders" hide-default-footer disable-pagination disable-sort>
                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                        <span slot="item.amount" slot-scope="{item}">{{ parseInt(+item.amount || 0).format() }}원</span>
                        <span slot="item.remain" slot-scope="{item}">{{ parseInt(+item.remain || 0).format() }}원</span>
                    </v-data-table>
                </div>
            </v-card>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
            </div>
        </v-responsive>
    </component>
</template>
<script>
import api from "@/api";
export default {
    data(){
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            points: [],
            pointsHeaders: [
                { text: "적립/사용일자", value: "createdAt", align: "center", width: 200 },
                { text: "비고", value: "remark", align: "center" },
                { text: "포인트", value: "amount", align: "center", width: 150 },
            ],
            me: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.search();
        },
        async search(routable = false){
            let { summary, points } = await api.v1.me.points.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            });

            this.points = points;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); }
    }
}
</script>